export const environment = {
  production: false,
  apiUrl: 'https://funrun-dev.kursusflutter.com/v1/',
  langDefault: 'id',
};
